import { render, staticRenderFns } from "./resetStatusChangeWarnList.vue?vue&type=template&id=6456d588&scoped=true"
import script from "./resetStatusChangeWarnList.vue?vue&type=script&lang=js"
export * from "./resetStatusChangeWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456d588",
  null
  
)

export default component.exports